// Edit this file to add, remove, reorder, or update faculty members for this department.
const facultyData = {
  "hod": {
    "id": "f-venkatesh-shankar",
    "name": "Dr. Venkatesh Shankar",
    "designation": "Professor and HOD",
    "role": "Professor and HOD",
    "qualification": "M.Tech., Ph.D.",
    "qualifications": "M.Tech., Ph.D.",
    "image": "/FacultyCImages/DR_venkatesh_shankar_CSE.jpeg",
    "email": "hodcse@klsvdit.edu.in",
    "phone": "+91 99641 45566",
    "showPhone": true,
    "experience": "16 years",
    "description": "Dr. Venkatesh Shankar is a Professor and academic leader with a Ph.D. in Wireless Sensor Networks. He is currently guiding six research scholars, has published four patents, served as IQAC Head and Dean (Academics), and received the Best Teacher Award (2015) at SIT College of Engineering, Ichalkaranji, Maharashtra, for excellence in teaching and academic leadership.",
    "bio": "Dr. Venkatesh Shankar is a Professor and academic leader with a Ph.D. in Wireless Sensor Networks. He is currently guiding six research scholars, has published four patents, served as IQAC Head and Dean (Academics), and received the Best Teacher Award (2015) at SIT College of Engineering, Ichalkaranji, Maharashtra, for excellence in teaching and academic leadership.",
    "specializations": [
      "Wireless Sensor Networks (WSN)",
      "Artificial Intelligence and Machine Learning (AIML)",
      "Web Technology",
      "Data Structures"
    ],
    "areas": [
      "Wireless Sensor Networks (WSN)",
      "Artificial Intelligence and Machine Learning (AIML)",
      "Web Technology",
      "Data Structures"
    ],
    "courses": [
      "Software Engineering",
      "Web Technology",
      "Computer Networks",
      "Machine Learning"
    ],
    "publications": 22,
    "projects": 2,
    "linkedin": "https://in.linkedin.com/in/dr-venkatesh-shankar-96929937",
    "irins": "https://klsvdit.irins.org/profile/259186",
    "recognition": [
      "A member of A member of Indian Society for Technical Education (ISTE)",
      "A member of Computer Society of India (CSI)",
      "A member of Association for Computing Machinery (ACM) member",
      "Board of Studies (BOS) member at Sanjay Bhokare Group of Institutes (SBGI) Miraj",
      "Centre for Development of Advanced Computing (C-DAC) Gold certificate",
      "Visvesvaraya Technological University (VTU) Research Advisory Committee (RAC) member"
    ]
  },
  "members": [
    {
      "id": "f-sunita-kallu",
      "name": "Mrs. Sunita Kallu",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/sunita_kallu_CSE.jpeg",
      "email": "snk@klsvdit.edu.in",
      "phone": "+91 99162 38462",
      "showPhone": false,
      "experience": "8 years",
      "description": "Mrs. Sunita Kallu is a faculty member in the Department of Computer Science & Engineering at KLS VDIT. Her research interests include Wireless Sensor Networks and related communication technologies. She is committed to teaching, research, and fostering student learning through practical and innovative approaches.",
      "bio": "Mrs. Sunita Kallu is a faculty member in the Department of Computer Science & Engineering at KLS VDIT. Her research interests include Wireless Sensor Networks and related communication technologies. She is committed to teaching, research, and fostering student learning through practical and innovative approaches.",
      "specializations": [
        "Wireless Sensors Networks",
        "Computer Networks",
        "Cryptography and Network Security",
        "Artificial intelligence"
      ],
      "areas": [
        "Wireless Sensors Networks",
        "Computer Networks",
        "Cryptography and Network Security",
        "Artificial intelligence"
      ],
      "courses": [
        "Software Engineering And Project Management",
        "Cloud Computing",
        "Parallel Computing",
        "Database Management Systems"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "",
      "irins": "",
      "recognition": [
        "A member of Association for Computing Machinery (ACM)"
      ]
    },
    {
      "id": "f-shree-gowri-s-s",
      "name": "Mrs. Shree Gowri S S",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/shreegouri_s_s_CSE.jpeg",
      "email": "sss@klsvdit.edu.in",
      "phone": "+91 80952 07200",
      "showPhone": false,
      "experience": "15 years",
      "description": "Mrs.Shree Gowri S. S. is working as an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. She has been serving since 2010 and is dedicated to teaching and mentoring students. She has handled various subjects in Computer Science and Engineering and strongly believes that hard work, discipline, and continuous learning are the keys to success.",
      "bio": "Mrs.Shree Gowri S. S. is working as an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. She has been serving since 2010 and is dedicated to teaching and mentoring students. She has handled various subjects in Computer Science and Engineering and strongly believes that hard work, discipline, and continuous learning are the keys to success.",
      "specializations": [
        "Internet of Things (IoT)",
        "Wireless Sensor Networks"
      ],
      "areas": [
        "Internet of Things (IoT)",
        "Wireless Sensor Networks"
      ],
      "courses": [
        "Digital Design And Computer Organization",
        "Microcontroller",
        "Internet Of Things",
        "Introduction To C Programming"
      ],
      "publications": 2,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/shreegouri-ss-773276155",
      "irins": "https://klsvdit.irins.org/profile/249299",
      "recognition": [
        "A member of Indian Society for Technical Education (ISTE)",
        "A member of Institution of Engineers India (IEI) Member",
        "Completed National Programme on Technology Enhanced Learning (NPTEL) Course and attended FDPs (Faculty Development Programmes)"
      ]
    },
    {
      "id": "f-vijet-swadi",
      "name": "Mr. Vijet Swadi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/vijet_swadi_CSE.jpeg",
      "email": "vbs@klsvdit.edu.in",
      "phone": "+91 99642 23710",
      "showPhone": false,
      "experience": "13 years",
      "description": "Mr. Vijet Swadi is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with 13 years of teaching experience. His interests include Machine Learning, Web Technologies, and Natural Language Processing. He teaches Programming, Operating Systems, and Software Engineering, and actively guides innovative student projects and research initiatives.",
      "bio": "Mr. Vijet Swadi is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with 13 years of teaching experience. His interests include Machine Learning, Web Technologies, and Natural Language Processing. He teaches Programming, Operating Systems, and Software Engineering, and actively guides innovative student projects and research initiatives.",
      "specializations": [
        "Machine Learning",
        "Web tehnology",
        "Natural Language Processin"
      ],
      "areas": [
        "Machine Learning",
        "Web tehnology",
        "Natural Language Processin"
      ],
      "courses": [
        "C Programming",
        "Web Technology",
        "Operating System",
        "Software Engineering"
      ],
      "publications": 3,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/vijet-swadi-b749a018/",
      "irins": "https://klsvdit.irins.org/profile/715497",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-pranesh-kulkarni",
      "name": "Mr. Pranesh Kulkarni",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/pranesh_kulkarni_CSE.jpeg",
      "email": "pkk@klsvdit.edu.in",
      "phone": "+91 95387 23414",
      "showPhone": false,
      "experience": "10 years",
      "description": "Mr. Pranesh Kulkarni has a decade of academic experience in the Dept. of CSE at KLS VDIT, Haliyal. He had taught various programming and analytical courses for UG students. He is AWS course instructor.",
      "bio": "Mr. Pranesh Kulkarni has a decade of academic experience in the Dept. of CSE at KLS VDIT, Haliyal. He had taught various programming and analytical courses for UG students. He is AWS course instructor.",
      "specializations": [
        "Machine Learning"
      ],
      "areas": [
        "Machine Learning"
      ],
      "courses": [
        "Machine Learning",
        "Object-Oriented Programming (OOP) With C++",
        "Cryptography"
      ],
      "publications": 6,
      "projects": 4,
      "linkedin": "https://www.linkedin.com/in/pranesh-kulkarni-26bb84a0",
      "irins": "https://klsvdit.irins.org/profile/249274",
      "recognition": [
        "Qualified University Grants Commission (UGC) National Eligibility Test (NET) for Assistant Professor in Computer Application",
        "Qualified Graduate Aptitude Test in Engineering (GATE) Data Science and Artificial Intelligence (DA) 2025",
        "Member of Association for Computing Machinery (ACM)",
        "Faculty Development Programme (FDP) Attended - 10",
        "International Conference Attended - 03"
      ]
    },
    {
      "id": "f-girish-n-shivanagudi",
      "name": "Mr. Girish N Shivanagudi",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/girish_shivanagudi_CSE.jpeg",
      "email": "gns@klsvdit.edu.in",
      "phone": "+91 94493 65221",
      "showPhone": false,
      "experience": "10 years",
      "description": "Mr. Girish N S anchors Programming, Web Technologies, Java, and Data Structures courses in the Department of Computer Science & Engineering. With 10 years of teaching experience, he guides students in both theory and laboratory learning",
      "bio": "Mr. Girish N S anchors Programming, Web Technologies, Java, and Data Structures courses in the Department of Computer Science & Engineering. With 10 years of teaching experience, he guides students in both theory and laboratory learning",
      "specializations": [
        "Programming Languages",
        "Web Technologies",
        "Data Structures and Algorithms",
        "Machine Learning"
      ],
      "areas": [
        "Programming Languages",
        "Web Technologies",
        "Data Structures and Algorithms",
        "Machine Learning"
      ],
      "courses": [
        "Data Structures Using C",
        "Design And Analysis Of Algorithms (DAA)",
        "Java Programming",
        "Python"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/girish-shivanagudi-3b1a07349",
      "irins": "https://klsvdit.irins.org//profile/715562",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-apoorva-sabnis",
      "name": "Mrs. Apoorva Sabnis",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/apoorva_sabnis_CSE.jpeg",
      "email": "and@klsvdit.edu.in",
      "phone": "+91 76192 81253",
      "showPhone": false,
      "experience": "1 years",
      "description": "Mrs. Apoorva Sabnis is a faculty member in the Department of Computer Science & Engineering. Her areas of interest include Artificial Intelligence, Machine Learning, and Data Science. She is passionate about teaching and mentoring students, with a focus on developing practical and analytical skills in emerging technologies. She is committed to fostering innovation and preparing students to address real-world challenges.",
      "bio": "Mrs. Apoorva Sabnis is a faculty member in the Department of Computer Science & Engineering. Her areas of interest include Artificial Intelligence, Machine Learning, and Data Science. She is passionate about teaching and mentoring students, with a focus on developing practical and analytical skills in emerging technologies. She is committed to fostering innovation and preparing students to address real-world challenges.",
      "specializations": [
        "Artificial Intelligence (AI)",
        "Machine Learning (ML)",
        "Deep Learning (DL)",
        "Data Science"
      ],
      "areas": [
        "Artificial Intelligence (AI)",
        "Machine Learning (ML)",
        "Deep Learning (DL)",
        "Data Science"
      ],
      "courses": [
        "C Programming",
        "Biology For Computer Engineers"
      ],
      "publications": 0,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/apoorva-sabnis-2ba001160",
      "irins": "https://klsvdit.irins.org/profile/715560",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-farajanabegaum-nadaf",
      "name": "Mrs. Farajanabegaum Nadaf",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/farajanabegum_nadaf_CSE.jpeg",
      "email": "fnn@klsvdit.edu.in",
      "phone": "+91 99866 85800",
      "showPhone": false,
      "experience": "18 years",
      "description": "Mrs. Farajanabegaum Nadaf is an accomplished academician with 18 years of experience in Computer Science and Engineering, serving as an Assistant Professor. Her expertise includes Data Structures, Internet of Things, Blockchain, and Edge-IoT systems. She is committed to excellence in teaching, research, student mentorship, and industry-oriented learning.",
      "bio": "Mrs. Farajanabegaum Nadaf is an accomplished academician with 18 years of experience in Computer Science and Engineering, serving as an Assistant Professor. Her expertise includes Data Structures, Internet of Things, Blockchain, and Edge-IoT systems. She is committed to excellence in teaching, research, student mentorship, and industry-oriented learning.",
      "specializations": [
        "Internet of Things (IoT)",
        "Big Data Analytics",
        "Cloud Computing",
        "Web Technology"
      ],
      "areas": [
        "Internet of Things (IoT)",
        "Big Data Analytics",
        "Cloud Computing",
        "Web Technology"
      ],
      "courses": [
        "Python",
        "Web Programming",
        "Blockchain Technology",
        "Compiler Design"
      ],
      "publications": 4,
      "projects": 6,
      "linkedin": "https://www.linkedin.com/in/farzana-nadaf-a1794918/",
      "irins": "https://klsvdit.irins.org/profile/249267",
      "recognition": [
        "Appreciated for successfully leading student teams whose projects were shortlisted and funded by Karnataka State Council for Science and Technology (KSCST), demonstrating strong mentorship and research orientation",
        "Short Term Training Programme (STTP) COURSE ON Blockchain Technology,",
        "National Programme on Technology Enhanced Learning (NPTEL) Courses on Internet of Things (IoT),Research Methodology"
      ]
    },
    {
      "id": "f-nirmala-ganiger",
      "name": "Mrs. Nirmala Ganiger",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/nirmala_ganiger_CSE.jpeg",
      "email": "ng@klsvdit.edu.in",
      "phone": "+91 97432 52068",
      "showPhone": false,
      "experience": "6 years",
      "description": "Mrs. Nirmala Ganiger is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with six years of teaching experience. Her areas of interest include Artificial Intelligence, Cybersecurity, Data Science, and Software Engineering. She is dedicated to teaching, research, and nurturing students' technical, practical, and innovative skills.",
      "bio": "Mrs. Nirmala Ganiger is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT with six years of teaching experience. Her areas of interest include Artificial Intelligence, Cybersecurity, Data Science, and Software Engineering. She is dedicated to teaching, research, and nurturing students' technical, practical, and innovative skills.",
      "specializations": [
        "Data Science and Big Data Analytics",
        "Natural Language Processing (NLP)",
        "Quantum Computing",
        "Cloud Computing"
      ],
      "areas": [
        "Data Science and Big Data Analytics",
        "Natural Language Processing (NLP)",
        "Quantum Computing",
        "Cloud Computing"
      ],
      "courses": [
        "Uniplexed Information And Computing System (UNIX)",
        "Database Management System",
        "Digital Design And Computer Organization (DDCO)",
        "C Programming"
      ],
      "publications": 5,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/nirmala-ganiger-1b9a5038?utm_source=share_via&utm_content=profile&utm_medium=member_android",
      "irins": "https://klsvdit.irins.org/profile/564064",
      "recognition": [
        "information to be updated"
      ]
    },
    {
      "id": "f-nancy-p",
      "name": "Mrs. Nancy P",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/Nancy_P_CSE.jpeg",
      "email": "np@klsvdit.edu.in",
      "phone": "+91 94805 94727",
      "showPhone": false,
      "experience": "14 years",
      "description": "Mrs. Nancy P. is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. Her academic interests include Artificial Intelligence, Big Data Analytics, and Microcontrollers. She actively coordinates student activities, contributes to academic development, and is committed to fostering innovation, social responsibility, and student success.",
      "bio": "Mrs. Nancy P. is an Assistant Professor in the Department of Computer Science and Engineering at KLS VDIT. Her academic interests include Artificial Intelligence, Big Data Analytics, and Microcontrollers. She actively coordinates student activities, contributes to academic development, and is committed to fostering innovation, social responsibility, and student success.",
      "specializations": [
        "Computer Scinece and Engineering",
        "Artificial intelligence"
      ],
      "areas": [
        "Computer Scinece and Engineering",
        "Artificial intelligence"
      ],
      "courses": [
        "Big Data Analysis",
        "Microcontroller ( 2 Div)",
        "Social Connect And Responsibility"
      ],
      "publications": 1,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/nancy-p-21b4a0406",
      "irins": "https://klsvdit.irins.org//profile/710389",
      "recognition": [
        "Received appreciation letter from Head of Institution (HOI) for big Data analytics for students feedback",
        "Mtech in Electronics and Communication Engineering (EC)"
      ]
    },
    {
      "id": "f-bhagat-inamdar",
      "name": "Mr. Bhagat Inamdar",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/bhagat_inamdar_CSE.jpeg",
      "email": "bgi@klsvdit.edu.in",
      "phone": "+91 98800 89908",
      "showPhone": false,
      "experience": "3 years",
      "description": "Mr. Bhagat Inamdar is an Assistant Professor in the Department of Computer Science & Engineering at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His areas of interest include Wireless Sensor Networks, Network Routing Algorithms, and Cyber Security.",
      "bio": "Mr. Bhagat Inamdar is an Assistant Professor in the Department of Computer Science & Engineering at KLS Vishwanathrao Deshpande Institute of Technology, Haliyal. His areas of interest include Wireless Sensor Networks, Network Routing Algorithms, and Cyber Security.",
      "specializations": [
        "Computer Network"
      ],
      "areas": [
        "Computer Network"
      ],
      "courses": [
        "Computer Networks",
        "Database Management System (DBMS)",
        "C++"
      ],
      "publications": 4,
      "projects": 1,
      "linkedin": "https://www.linkedin.com/in/bhagat-inamdar-57638055/",
      "irins": "https://klsvdit.irins.org/profile/483123",
      "recognition": [
        "Member of professional bodies including Computer Society of India (CSI)",
        "Association for Computing Machinery (ACM)"
      ]
    },
    {
      "id": "f-samyukta-guddin",
      "name": "Ms. Samyukta Guddin",
      "designation": "Assistant Professor",
      "role": "Assistant Professor",
      "qualification": "M.Tech.",
      "qualifications": "M.Tech.",
      "image": "/FacultyCImages/samyukta_guddin_CSE.png",
      "email": "sg@klsvdit.edu.in",
      "phone": "+91 8310981398",
      "showPhone": false,
      "experience": "",
      "description": "Passionate about teaching, research, and mentoring students, with a commitment to fostering innovation, analytical thinking, and problem-solving abilities. Dedicated to equipping learners with the knowledge and skills required to excel in emerging technologies and address real-world challenges.",
      "bio": "Passionate about teaching, research, and mentoring students, with a commitment to fostering innovation, analytical thinking, and problem-solving abilities. Dedicated to equipping learners with the knowledge and skills required to excel in emerging technologies and address real-world challenges.",
      "specializations": [
        "Wireless Sensors Networks",
        "Computer Networks",
        "Cryptography and Network Security",
        "Artificial intelligence"
      ],  
      "areas": [
        "Artificial Intelligence and Machine Learning",
        "Data Structures",
        "Cryptography and Network Security",
        
      ], 
      "courses": [
        "UNIX Programming",
        "Cryptography and Network Security",
        
      ],
      "publications": 2,
      "projects": 0,
      "linkedin": "https://www.linkedin.com/in/samyukta-guddin-733128224",
      "irins": "https://klsvdit.irins.org//profile/710395",
      
    }
  ]
};

export default facultyData;
